<template>
  <div>
    <h1 :class="$style.pageTitle">グループ作成</h1>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form-group />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@/assets/styles/mixins.scss';
</style>
<script>
import FormGroup from '../../../components/FormComponents/Group'

export default {
  components: {
    FormGroup,
  },
}
</script>
